import axios from 'axios';
import CryptoJS from "crypto-js";

// Initialize encryption keys
const AES_SECRET_KEY = process.env.REACT_APP_AES_KEY;
const formattedKey = CryptoJS.enc.Base64.parse(AES_SECRET_KEY);
const iv = formattedKey.clone();

// Decryption function
const decryptData = async (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, formattedKey, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: iv,
    });

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption failed");
    return null;
  }
};

// Create axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/api',
  headers: {
    'Content-Type': 'application/json',
  }
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  async (response) => {
    if (response.data?.encrypted_data) {
      const decryptedData = await decryptData(response.data.encrypted_data);
      return { data: decryptedData };
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('refresh_token');

      if (refreshToken) {
        try {
          const refreshUrl = `${process.env.REACT_APP_API_URL}/api/token/refresh/`;
          const { data } = await axios.post(refreshUrl, { refresh: refreshToken });

          localStorage.setItem('access_token', data.access);
          originalRequest.headers['Authorization'] = `Bearer ${data.access}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;